import XDate from 'xdate'
import {
  faBullhorn,
  faCalendarDays,
  faChartSimple,
  faComments,
  faFolderOpen,
  faReceipt,
  faWrench,
} from '@fortawesome/pro-duotone-svg-icons'

import { ResidentComingSoon, ResidentQuickAction } from './types'

const RESIDENT_QUICK_ACTIONS: ResidentQuickAction[] = [
  {
    to: '/payments',
    icon: faReceipt,
    title: 'Payments',
    subtitle: 'Pay rent, set up autopay, and review your ledger.',
  },
  {
    to: '/maintenance',
    icon: faWrench,
    title: 'Maintenance',
    subtitle: 'Report an issue and track it to done.',
  },
  {
    to: '/announcements',
    icon: faBullhorn,
    title: 'Announcements',
    subtitle: 'Updates and notices from your property manager.',
  },
  {
    to: '/documents',
    icon: faFolderOpen,
    title: 'Documents',
    subtitle: 'View and download your lease, notices, and receipts.',
  },
  {
    to: '/polls',
    icon: faChartSimple,
    title: 'Polls',
    subtitle: 'Vote on quick polls from your property manager.',
  },
  {
    to: '/amenities',
    icon: faCalendarDays,
    title: 'Amenities',
    subtitle: 'Browse the shared amenities at your building.',
  },
]

const RESIDENT_COMING_SOON: ResidentComingSoon[] = [
  { icon: faComments, title: 'Community' },
]

/**
 * Picks a time-of-day-aware greeting prefix for the resident home.
 *
 * @returns {string}
 */
const getResidentGreeting = (): string => {
  const hours = new XDate().getHours()

  if (hours < 5) {
    return 'Up late'
  }

  if (hours < 12) {
    return 'Good morning'
  }

  if (hours < 17) {
    return 'Good afternoon'
  }

  return 'Good evening'
}

export { RESIDENT_QUICK_ACTIONS, RESIDENT_COMING_SOON, getResidentGreeting }
